export const STATUS_2FA_ENABLED = 'enabled';
export const STATUS_2FA_FORBIDDEN = 'forbidden';
export const STATUS_2FA_AVAILABLE = 'available';
